import { c as _c } from "react/compiler-runtime";
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { ArrowDownIcon, CloseIcon } from '@systemeio/ui/icons';
import { CurrencyEnum, centsToUnits } from '@systemeio/ui';
import { useAffiliateDashboardVendors } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-vendors';
import { AffiliateDashboardFilterInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardVendorsInterface, VendorId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-vendors-interface';
import React, { Fragment, useEffect, useState } from 'react';
import { Loader } from 'shared/components/loader';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
interface AffiliateVendorSelectorProps {
  selectedVendor?: VendorId;
  setFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardVendorSelector = t0 => {
  const $ = _c(49);
  const {
    selectedVendor,
    setFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [shouldFetch, setShouldFetch] = useState(false);
  let t1;
  let t2;
  if ($[0] !== selectedVendor) {
    t1 = () => {
      if (selectedVendor) {
        setShouldFetch(true);
      }
    };
    t2 = [selectedVendor];
    $[0] = selectedVendor;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const {
    data: vendors
  } = useAffiliateDashboardVendors(shouldFetch);
  let t3;
  if ($[3] !== selectedVendor || $[4] !== vendors) {
    t3 = vendors?.find(el => el.vendor.id === selectedVendor)?.vendor.affiliateProgramBrandName;
    $[3] = selectedVendor;
    $[4] = vendors;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const selectedVendorName = t3;
  let t4;
  if ($[6] !== t) {
    t4 = t("dashboard.affiliate_dashboard.vendor");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== selectedVendor) {
    t5 = vendor => <div className="w-full truncate"><span className={`${vendor.vendor.id === selectedVendor ? "text-brand-primary" : "text-text-primary"} w-full truncate`}>{vendor.vendor.affiliateProgramBrandName}</span></div>;
    $[8] = selectedVendor;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = {
      key: "vendor",
      header: t4,
      widthPercent: 30,
      onRender: t5
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("dashboard.affiliate.lifetime_earnings");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== selectedVendor || $[16] !== user?.dashboardLocale) {
    t8 = vendor_0 => <div className="flex flex-col gap-1.5">{Object.keys(vendor_0.sales).map((el_0, idx) => {
        const cur = el_0 as CurrencyEnum;
        return <span className={`${vendor_0.vendor.id === selectedVendor ? "text-brand-primary" : "text-text-primary"} `} key={idx}>{currencyFormat(centsToUnits(vendor_0.sales[cur]), cur, user?.dashboardLocale)}</span>;
      })}</div>;
    $[15] = selectedVendor;
    $[16] = user?.dashboardLocale;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = {
      key: "sales",
      header: t7,
      widthPercent: 30,
      onRender: t8
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("dashboard.affiliate.paid");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = `${t10} /`;
  let t12;
  if ($[23] !== t11) {
    t12 = <span className="text-text-primary">{t11}</span>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("dashboard.affiliate.pending");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = <span className="text-text-primary/50">{t13}</span>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t14) {
    t15 = <div className="flex gap-1">{t12}{t14}</div>;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== selectedVendor || $[33] !== user?.dashboardLocale) {
    t16 = vendor_1 => <div className="flex flex-col gap-1.5">{Object.keys(vendor_1.paid).map((el_1, idx_0) => {
        const cur_0 = el_1 as CurrencyEnum;
        return <div key={idx_0} className="flex gap-1"><span className={`${vendor_1.vendor.id === selectedVendor ? "text-brand-primary" : "text-text-primary"} `}>{`${currencyFormat(centsToUnits(vendor_1.paid[cur_0]), cur_0, user?.dashboardLocale)} /`}</span><span className={`${vendor_1.vendor.id === selectedVendor ? "text-brand-primary/50" : "text-text-primary/50"} `}>{currencyFormat(centsToUnits(vendor_1.pending[cur_0]), cur_0, user?.dashboardLocale)}</span></div>;
      })}</div>;
    $[32] = selectedVendor;
    $[33] = user?.dashboardLocale;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t15 || $[36] !== t16) {
    t17 = {
      key: "sales",
      widthPercent: 40,
      header: t15,
      onRender: t16
    };
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17 || $[39] !== t6 || $[40] !== t9) {
    t18 = [t6, t9, t17];
    $[38] = t17;
    $[39] = t6;
    $[40] = t9;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  const columns = t18;
  let t19;
  if ($[42] !== columns || $[43] !== selectedVendor || $[44] !== selectedVendorName || $[45] !== setFilter || $[46] !== t || $[47] !== vendors) {
    t19 = <Popover className="relative w-full">{t20 => {
        const {
          open
        } = t20;
        return <><PopoverButton className={`flex w-full items-center justify-between gap-3 truncate py-2.5 pl-4 lg:min-w-[200px] ${selectedVendor ? "pr-16" : "pr-10"} bg-background-secondary text-text-primary main-transition-colors rounded-lg border text-left text-sm ${open ? "border-brand-primary" : "border-text-secondary/30"} ${open && "border-brand-primary"} focus-visible:border-brand-primary text-text-primary placeholder:text-text-tertiary/70 focus:outline-hidden`}>{selectedVendor ? selectedVendorName ? <span className="truncate">{selectedVendorName}</span> : <Loader small={true} /> : <span>{t("dashboard.affiliate_dashboard.all_vendors")}</span>}{selectedVendor && <div onClick={e => {
              e.stopPropagation();
              setFilter(_temp);
            }} className="absolute inset-y-0 right-0 flex items-center pr-10"><CloseIcon className="fill-text-primary cursor-pointer" /></div>}<div className="absolute inset-y-0 right-0 flex items-center pr-4"><ArrowDownIcon className={`stroke-text-primary cursor-pointer transition-transform duration-300 ${open && "rotate-180"}`} aria-hidden="true" /></div></PopoverButton><Transition beforeEnter={() => setShouldFetch(true)} as={Fragment} enter="transition ease-out duration-200" enterFrom="opacity-0 translate-y-1" enterTo="opacity-100 translate-y-0" leave="transition ease-in duration-150" leaveFrom="opacity-100 translate-y-0" leaveTo="opacity-0 translate-y-1"><PopoverPanel className="absolute right-0 z-10 mt-1.5 w-screen max-w-sm transform px-4 sm:px-0 lg:max-w-3xl">{t21 => {
                const {
                  close
                } = t21;
                return <div className="bg-background-secondary customScroll max-h-[calc(100vh-350px)] overflow-hidden  overflow-y-auto rounded-lg shadow-lg ring-1 ring-black/5 sm:max-h-[calc(100vh-200px)]"><Table nestedId="vendor" onRowClick={vendor_2 => {
                    setFilter(prev_0 => ({
                      ...prev_0,
                      vendorId: vendor_2.vendor.id
                    }));
                    close();
                  }} data={vendors && {
                    hasMore: false,
                    items: vendors
                  }} columns={columns} /></div>;
              }}</PopoverPanel></Transition></>;
      }}</Popover>;
    $[42] = columns;
    $[43] = selectedVendor;
    $[44] = selectedVendorName;
    $[45] = setFilter;
    $[46] = t;
    $[47] = vendors;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  return t19;
};
export default AffiliateDashboardVendorSelector;
function _temp(prev) {
  return {
    ...prev,
    vendorId: undefined
  };
}